import React, { FC } from 'react';
import { Icon } from '@ss/mtd-react';
import { useRootStore } from '@src/model';
import dayjs from 'dayjs';
import { ICampusCampusExperience } from '@/src/types/resumeDetail/campusType';

import './index.scss';

interface IProps {
  type: string;
  data: ICampusCampusExperience[];
  setMode: Function;
}

const CampusExperienceView: FC<IProps> = (props) => {
  const { data, type, setMode } = props;
  const { campusResumeFormRefStore } = useRootStore();
  let storeRef;
  if (type === 'campus') {
    storeRef = campusResumeFormRefStore;
  }

  const handleEdit = () => {
    setMode('edit');
    storeRef.setCurrentScrollRef('campus_experience_edit');
  };

  return (
    <div className="campus_experience_view model_view">
      <div className="model_title">
        <div>校园经历</div>
        <div className="edit_icon" onClick={() => handleEdit()}>
          <Icon type="edit-o" style={{ color: '#A9AFB8', fontSize: 22 }} />
        </div>
      </div>
      {/* @ts-ignore */}
      {data?.map((item) => (
        <div className="model_list" key={item.renderId}>
          <div className="model_top">
            <div className="project_name">{item.experienceName || '-'}</div>
            <div className="project_time">
              {dayjs(item.startDate).isValid() ? dayjs(item.startDate).format('YYYY/MM') : ''}-
              {/* eslint-disable-next-line no-nested-ternary */}
              {item.endDate === 253370736000000
                ? '至今'
                : dayjs(item.endDate).isValid()
                  ? dayjs(item.endDate).format('YYYY/MM')
                  : ''}
            </div>
          </div>
          <div className="model_line" />
          <div className="model_bottom">
            <div className="label">
              <div className="label_left">角色：</div>
              <div className="label_right">{item.role || '-'}</div>
            </div>
            <div className="label">
              <div className="label_left">校园经历描述：</div>
              <div className="label_right">{item.experienceDescription || '-'}</div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default CampusExperienceView;
